import { action } from 'typesafe-actions';

import { PaymentTypes } from './types';

export const setHasShownPaidAlert = (showed: boolean) =>
  action(PaymentTypes.SET_PAID_ALERT, showed);
export const setShowPaidAlert = (showed: boolean) =>
  action(PaymentTypes.SET_SHOW_PAID_ALERT, showed);
